<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    class="accinventory-by-masterpayer"
  >
    <v-layout wrap>
      <v-flex
        md12
        lg4>
        <material-card
          color="orange"
          title="PPA"
          text="AWS Internal Accounts"
        >
          <v-data-table
            :headers="ppa_header"
            :items="ppaAccounts"
            :rowsPerPageItems="[]"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="font-weight-light text-warning text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="props"
            >
              <td class="mp-col">
                <router-link
                  :to="'/admin/account-inventory/master-payer/'+ props.item.MP_ID"
                  tag="div">
                  {{ props.item.MP_ID }} <span v-if="props.item.AWS_Support_Type">- {{ props.item.AWS_Support_Type }}</span>
                </router-link>
              </td>
              <td class="mp-col">
                <v-icon v-text="'mdi-dots-vertical'" title="validate master payer" @click="validateMasterPayer(props.item.MP_ID)"/>
              </td>
            </template>
          </v-data-table>

        </material-card>
      </v-flex>

      <v-flex
        md12
        lg4>
        <material-card
          color="orange"
          title="SPP"
          text="AWS External Accounts"
        >
          <v-data-table
            :headers="spp_header"
            :items="sppAccounts"
            :rowsPerPageItems="[]"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="font-weight-light text-warning text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="props"
            >
              <td class="mp-col">
                <router-link
                  :to="'/admin/account-inventory/master-payer/'+ props.item.MP_ID"
                  tag="div">
                  {{ props.item.MP_ID }} <span v-if="props.item.AWS_Support_Type">- {{ props.item.AWS_Support_Type }}</span>
                </router-link>
              </td>
              <td class="mp-col">
                <v-icon v-text="'mdi-dots-vertical'" title="validate master payer" @click="validateMasterPayer(props.item.MP_ID)"/>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>

      <v-flex
        md12
        lg4>
        <material-card
          color="orange"
          title="Legacy"
          text="Legacy Accounts"
        >
          <v-data-table
            :headers="legacy_header"
            :items="legacyAccounts"
            :rowsPerPageItems="[]"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="font-weight-light text-warning text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="props"
            >
              <td class="mp-col">
                <router-link
                  :to="'/admin/account-inventory/master-payer/'+ props.item.MP_ID"
                  tag="div">
                  {{ props.item.MP_ID }} <span v-if="props.item.AWS_Support_Type">- {{ props.item.AWS_Support_Type }}</span>
                </router-link>
              </td>
              <td class="mp-col">
                <v-icon v-text="'mdi-dots-vertical'" title="validate master payer" @click="validateMasterPayer(props.item.MP_ID)"/>
              </td>
            </template>
          </v-data-table>

        </material-card>
      </v-flex>

      <v-flex
        md12
        lg4>
        <material-card
          color="orange"
          title="EDP"
          text="EDP Accounts"
        >
          <v-data-table
            :headers="edp_header"
            :items="edpAccounts"
            :rowsPerPageItems="[]"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="font-weight-light text-warning text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="props"
            >
              <td class="mp-col">
                <router-link
                  :to="'/admin/account-inventory/master-payer/'+ props.item.MP_ID"
                  tag="div">
                  {{ props.item.MP_ID }} <span v-if="props.item.AWS_Support_Type">- {{ props.item.AWS_Support_Type }}</span>
                </router-link>
              </td>
              <td class="mp-col">
                <v-icon v-text="'mdi-dots-vertical'" title="validate master payer" @click="validateMasterPayer(props.item.MP_ID)"/>
              </td>
            </template>
          </v-data-table>
          
        </material-card>
      </v-flex>

      <v-flex
        md12
        lg4>
        <material-card
          color="orange"
          title="All"
          text="AWS Accounts"
        >
          <v-data-table
            :headers="all_header"
            :items="allAccounts"
            :rowsPerPageItems="[]"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="font-weight-light text-warning text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="props"
            >
              <td class="mp-col">
                <router-link
                  :to="'/admin/account-inventory/master-payer/'+ props.item.MP_ID"
                  tag="div">
                  {{ props.item.MP_ID }} <span v-if="props.item.AWS_Support_Type">- {{ props.item.AWS_Support_Type }}</span>
                </router-link>
              </td>
              <td class="mp-col">
                <v-icon v-text="'mdi-dots-vertical'" title="validate master payer" @click="validateMasterPayer(props.item.MP_ID)"/>
              </td>
            </template>
          </v-data-table>
          
        </material-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
// Utilities
import {
  mapState
} from 'vuex'

export default {
  filters: {
    truncate: function (value) {
      return value.substr(value.length - 4)
    }
  },
  data () {
    return {
      ppa_header: [
        {
          sortable: true,
          text: 'AWS Support Type',
          value: 'Master_Id'
        }
      ],
      spp_header: [
        {
          sortable: true,
          text: 'AWS Support Type',
          value: 'Master_Id'
        }
      ],
      sp_header: [
        {
          sortable: true,
          text: 'AWS Support Type',
          value: 'Master_Id'
        }
      ],
      other_header: [
        {
          sortable: true,
          text: 'AWS Support Type',
          value: 'Master_Id'
        }
      ],
      all_header: [
        {
          sortable: true,
          text: 'AWS Support Type',
          value: 'Master_Id'
        }
      ],
      legacy_header: [
        {
          sortable: true,
          text: 'AWS Support Type',
          value: 'Master_Id'
        }
      ],
      edp_header: [
        {
          sortable: true,
          text: 'AWS Support Type',
          value: 'Master_Id'
        }
      ],
      tabs: 0,
      list: {
        0: false,
        1: false,
        2: false
      }

    }
  },

  computed: {
    ...mapState('admin/accountInventory', ['masterPayers', 'accountHeaders']),
    ppaAccounts () {
      return this.masterPayers.filter(mp => mp.Agreement.toLowerCase() === 'ppa')
    },
    sppAccounts () {
      return this.masterPayers.filter(mp => mp.Agreement.toLowerCase() === 'spp')
    },
    allAccounts () {
      return this.masterPayers
    },
    legacyAccounts () {
      return this.masterPayers.filter(mp => mp.Agreement.toLowerCase() === 'legacy')
    },
    edpAccounts () {
      return this.masterPayers.filter(mp => mp.Agreement.toLowerCase().indexOf('edp -') !== -1)
    }
  },
  methods: {
    complete (index) {
      this.list[index] = !this.list[index]
    },
    validateMasterPayer(master_payer) {
      console.log('validateMasterPayer: ', master_payer)
      this.$store.dispatch("admin/accountInventory/validateAccountDetails", master_payer);
    }
  }
}

</script>
<style lang='scss' scoped>
  .accinventory-by-masterpayer {
    .mp-col {
      cursor: pointer;
      &:hover {
        font-weight: 500;
      }
    }

    .mp-button{
     list-style: none;
     text-align: center;
     float: left;
     margin-right: 5px;
   }

  }
</style>
